/**
 * this mixin will load account and user state from the vuex store and provide methods for:
 *  * signIn
 *  * signOut
 *  * signUp
 *  * confirmSignUp
 *  * resendSignUp
 */

import { mapActions, mapGetters } from 'vuex';
import { LoggerService } from '@/services';
import { Auth } from 'aws-amplify';

export default {
  computed: {
    ...mapGetters({
      loggedInEmail: 'tokeny/email',
      isLoggedIn: 'tokeny/isLoggedIn',
      locale: 'locale/locale'
    })
  },
  methods: {
    ...mapActions({
      setUserEmail: 'qualification/setUserEmail',
      qualificationReset: 'qualification/reset',
      tokenyLogin: 'tokeny/login',
      tokenyLogout: 'tokeny/logout',
      forgotPassword: 'tokeny/forgotPassword',
      forgotPasswordConfirm: 'tokeny/forgotPasswordConfirm'
    }),
    async signOut () {
      try {
        await this.tokenyLogout();
        await this.qualificationReset();
      } catch (error) {
        LoggerService.error(error);
      }
    },
    async signIn ({ email, password }) {
      try {
        await this.tokenyLogin({
          username: email,
          password: password
        });
        this.setUserEmail(email);
      } catch (error) {
        if (
          error.code === 'UserNotFoundException' ||
          error.code === 'NotAuthorizedException'
        ) {
          LoggerService.info(this.$t('view.SignIn.failureMessage'));
          throw (error);
        } else if (error.code === 'UserNotConfirmedException') {
          LoggerService.info(this.$t('view.ConfirmSignUp.title'));
          this.setUserEmail(this.email);
          throw (error);
        } else {
          LoggerService.error(error);
        }
      }
    },
    async signUp ({ username, password }) {
      return Auth.signUp({
        username,
        password,
        attributes: {
          website: `${window.location.hostname}`
        },
        clientMetadata: {
          language: this.locale
        }
      });
    },
    async confirmSignUp ({ username, code }) {
      return Auth.confirmSignUp(username, code);
    },
    async resendSignUp ({ username }) {
      await Auth.resendSignUp(username);
    }
  }
};
